import { $one, $all } from "../utils/querySelector"
import { dataToggle } from "../utils/toggleDataActive";

/**
 * Loop to change all dataset active in button accordions
 *
 * @param {String} nodeAll - Reference to search in parent element
 * @param {HTMLElement} parent - Parent to valuate
 * @returns Action to change dataset active to 'false' at all buttons
 */
 export function closeAll(nodeAll, parent) {
  return $all(nodeAll, parent)
    .forEach((node) => {
      // eslint-disable-next-line no-param-reassign
      node.dataset.active = 'false'
    })
}

/**
 * DropDown Action - if is not data active true
 * @param {HTMLElement} element - Node to change data active
 */
 function dropDownAction(element, event) {
  // eslint-disable-next-line no-unused-expressions
  const active = element.dataset.active;

  active !== 'true'
    && closeAll('.nav-item-js .button-dropdown-js', $one('#menu-nav'));

  if(event === 'mouseenter' && active === 'false') {
    dataToggle(element);
  } else if(event === 'mouseleave' && active === 'true') {
    dataToggle(element);
  }
}

/**
 * Event dropDown
 * @param {HTMLElement} node - Event target node
 * @param {EventListener} event - Type event
 * @param {HTMLElement} nodeOnAction - Node to change data active
 * @returns Function Event
 */
 function eventDropDown(
  node,
  event,
  nodeOnAction,
) {
  return node.addEventListener(event, () => {
    dropDownAction(nodeOnAction, event)
  })
}

/**
 * Open dropdown menu - click / mouseentre event
 * To select type event check data-event in node#menu-nav
 */
export function openDropDown() {
  if (!$one('#menu-nav')) return;
  const { dataset } = $one('#menu-nav');

  // eslint-disable-next-line no-undef
  if (dataset.event === 'click' || innerWidth < 800) {
    $all('.button-dropdown-js')
      .forEach((item) => (
        eventDropDown(item, 'click', item)
      ))
  } else {
    $all('.nav-item-js')
      .forEach((item) => {
        eventDropDown(item, 'mouseenter', item.children[0])
        eventDropDown(item, 'mouseleave', item.children[0])
      })
  }
}
